import { RouteConfig } from 'vue-router';

export const userManagementChildren: Array<RouteConfig> = [
  {
    path: '',
    name: 'user-management',
    component: (): Promise<typeof import('vue')> => import(/* webpackChunkName: "main" */ '../views/UserManagement.vue')
  },
  {
    path: ':userId/edit',
    name: 'user-management-edit',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '@/components/user-management/user-management-edit/UserManagementEdit.vue')
  },
  {
    path: '',
    redirect: {
      name: 'user-management'
    }
  }
];
